import { KeyboardReturn } from '@mui/icons-material';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useQuerySavePopover } from './QuerySavePopover.hooks';
import { PopoverArrowStyled } from './QuerySavePopover.styled';
import { QuerySavePopoverProps } from './QuerySavePopover.types';

export const QuerySavePopover = (props: QuerySavePopoverProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'FilterSavePopover' });
  const { value, onChange, onSave, getInputProps, getRootProps, getPopoverProps } = useQuerySavePopover(props);

  return (
    <PopoverArrowStyled
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...getPopoverProps()}
    >
      <Box
        {...getRootProps()}
        sx={{
          p: 4,
        }}
      >
        <Typography variant="subtitle1" gutterBottom>
          {t('title')}
        </Typography>
        <TextField
          value={value}
          sx={{ width: 256 }}
          variant="outlined"
          size="small"
          type="text"
          placeholder={t('placeholder')}
          onChange={onChange}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment sx={{ color: value ? 'text.primary' : 'text.secondary' }} position="end">
                  <KeyboardReturn fontSize="small" sx={{ cursor: 'pointer' }} color="inherit" onClick={onSave} />
                </InputAdornment>
              ),
            },

            htmlInput: getInputProps(),
          }}
        />
      </Box>
    </PopoverArrowStyled>
  );
};
